import { injectable } from "inversify";
import { Dispatch, SetStateAction } from "react";
import SortingItemDescriptor from "features/shared/components/sorting/models/SortingItemDescriptor";
import { ISortingStateHandler } from "./ISortingStateHandler";
import { SortingDirection } from "../models/SortingDirection";
import { SortingMode } from "../models/SortingMode";

@injectable()
export class SortingStateHandler implements ISortingStateHandler {

  loadSortingDescriptors(dataSortJson: string): SortingItemDescriptor[] {
    try {
      const descriptors = JSON.parse(
        dataSortJson
      ) as SortingItemDescriptor[];

      if (descriptors && descriptors.length > 0) {
        return descriptors.map((x) =>({
          ...x,
          sortMode: x.sortMode ?? SortingMode.Direction
        }));
      }
    } catch (error) {}

    return [];
  }

  getUrlParamsOfActiveSorting(descriptors: SortingItemDescriptor[]): string {
    let activeDesc = descriptors.find((x) => x.active);

    if(!activeDesc) {
      return "";
    }

    const sortingUrlParams = new URLSearchParams({
      SortBy: activeDesc.name,
    });

    const sortMode = activeDesc.sortMode ?? SortingMode.Direction;

    if (sortMode === SortingMode.Direction && activeDesc.direction) {
      sortingUrlParams.append("SortDirection", activeDesc.direction);
    }

    return sortingUrlParams.toString();
  }

  changeSorting(
    name: string,
    direction: SortingDirection | undefined,
    descriptors: SortingItemDescriptor[],
    dispatchDescriptors: Dispatch<SetStateAction<SortingItemDescriptor[]>>
  ): void {
    let newDescriptors = [...descriptors];
    let activeDesc = newDescriptors.find((x) => x.active);
    let selectedDesc = newDescriptors.find((x) => x.name === name);

    if (activeDesc) {
      activeDesc.active = false;
      activeDesc.direction = undefined;
    } 
    if (selectedDesc) {
      selectedDesc.active = true;
      
      const sortMode = selectedDesc.sortMode ?? SortingMode.Direction;

      if (sortMode === SortingMode.Direction && direction) {
        selectedDesc.direction = direction;
      } else {
        selectedDesc.direction = undefined;
      }
    }

    dispatchDescriptors(newDescriptors);
  }

  changeSortingByUrlParams(
    sortingUrlSearchParams: string,
    descriptors: SortingItemDescriptor[],
    dispatchDescriptors: Dispatch<SetStateAction<SortingItemDescriptor[]>>
  ): void {
    if (!sortingUrlSearchParams) {
      return;
    }

    const sortingParamsFromStore = new URLSearchParams(sortingUrlSearchParams);
    let sortBy = sortingParamsFromStore.get("SortBy");
    let sortDirection = sortingParamsFromStore.get("SortDirection");

    if(!sortBy) {
      return;
    }

    const selectedDescriptor = descriptors.find((x) => x.name === sortBy);
    const sortMode = selectedDescriptor?.sortMode ?? SortingMode.Direction;

    if (sortMode === SortingMode.Other) {
      this.changeSorting(sortBy, undefined, descriptors, dispatchDescriptors);
    }

    if (sortDirection) {
      this.changeSorting(sortBy, sortDirection as any, descriptors, dispatchDescriptors);
    }
  }
}
